// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.op-text-button{padding:0;border:0;height:initial}`, "",{"version":3,"sources":["webpack://./app/new-components/DLS/OpTextButton/OpTextButton.scss"],"names":[],"mappings":"AAEA,gBACE,SAAA,CACA,QAAA,CACA,cAAA","sourcesContent":["@use 'assets/scss/common';\n\n.op-text-button {\n  padding: 0;\n  border: 0;\n  height: initial;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
